<flow-chart [config]="config"></flow-chart>